import axios from "axios";
import React, { useEffect, useState } from "react";
import { UserConsumer } from "../../../UserContext";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Link, Redirect, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table } from "../../../components/CustomPaginations";
import { statusColor, tableStyle } from "../../../components/TableStyle";
import Edit from "../../../images/edit.svg";
import Header from "../../../components/Header";
import { ViewEmployees_API } from "./ViewEmployees_API";
import FilterationBar from "./FilterationBar";
import CustomeSearchBar from "../../../components/CustomeSearchBar";
import { AlertPopups } from "../../../components/AlertPopups";
import moment from "moment";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { TableDateFormat } from "../../Dashboard/DashboardVariables";

function ViewEmployees() {
	let token,
		empRole,
		empDesignation,
		empId = null;

	let history = useHistory();
	const defaultSorted = [
		{
			dataField: "code",
			order: "asc",
		},
	];
	const [pageNum, setPageNum] = useState(1);
	const [searchInput, setSearchInput] = useState("");
	const [viewEmployeesData, setViewEmployeesData] = useState([]);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [designationList, setDesignationList] = useState([]);
	const [selectedDesignation, setSelectedDesignation] = useState(null);
	const [statusList, setStatusList] = useState(null);
	const [selectedStatus, setSelectedStatus] = useState(null);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [showBtnLoading, setShowBtnLoading] = useState(false);

	const getColumns = [
		{
			dataField: "code",
			text: "Code",
			sort: true,
			headerStyle: {
				width: "10%",
			},
		},
		{
			dataField: "name",
			text: "Name",
			sort: true,
			headerStyle: {
				width: "10%",
			},
		},
		{
			dataField: "designation",
			text: "Designation",
			sort: true,
			headerStyle: {
				width: "10%",
			},
		},
		{
			dataField: "loginInfo",
			text: "Login Info",
			sort: true,
			headerStyle: {
				width: "10%",
			},
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
			headerStyle: {
				width: "10%",
			},
			style: statusColor,
		},
		{
			dataField: "remainingLeaves",
			text: "Remaining Leaves",
			sort: true,
			headerStyle: {
				width: "20%",
			},
			formatter: (cell, row) => {
				return (
					<span>
						{row.withoutPay +
							row.sick +
							row.annual +
							row.compensation +
							row.maternity +
							row.others}
					</span>
				);
			},
		},
		{
			dataField: "action",
			text: "Action",
			events: {
				onClick: (e) => {
					e.stopPropagation(); // To stop navigation to detail screen
				},
			},
			formatter: (cell, row) => {
				return (
					<>
						<div className="navLinkClass align-items-center">
							<Link
								to={{
									pathname: `/ModifyEmployee/${row.id}`,
								}}
							>
								<img
									style={
										empDesignation.toString() === "4" ||
										empId === "180"
											? { height: "20px", width: "20px" }
											: {
													height: "20px",
													width: "20px",
													marginRight: "6px",
											  }
									}
									src={Edit}
									alt="Edit"
									title="Modify Employee"
								/>
							</Link>
							{empDesignation.toString() === "4" ||
							empId === "180" ? null : (
								<Link
									to={
										empRole.includes("3")
											? {
													pathname: `/AdminViewResourceLeavesInfo/${row.id}`,
											  }
											: {
													pathname: `/spResourceLeavesInfo/${row.id}`,
											  }
									}
								>
									<FontAwesomeIcon
										title="View Leaves Info"
										icon={faEye}
										style={{
											height: "20px",
											width: "20px",
											verticalAlign: "middle",
											marginLeft: "10px",
											color: "#43a3a5",
										}}
									/>
								</Link>
							)}
						</div>
					</>
				);
			},
		},
	];

	const adminGetColumns = [
		{
			dataField: "code",
			text: "Code",
			sort: true,
			headerStyle: {
				width: "10%",
			},
		},
		{
			dataField: "name",
			text: "Name",
			sort: true,
			headerStyle: {
				width: "10%",
			},
		},
		{
			dataField: "designation",
			text: "Designation",
			sort: true,
			headerStyle: {
				width: "10%",
			},
		},

		{
			dataField: "loginInfo",
			text: "Login Info",
			sort: true,
			headerStyle: {
				width: "10%",
			},
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
			headerStyle: {
				width: "10%",
			},
			style: statusColor,
		},
		{
			dataField: "remainingLeaves",
			text: "Remaining Leaves",
			sort: true,
			headerStyle: {
				width: "20%",
			},
			formatter: (cell, row) => {
				return (
					<span>
						{row.withoutPay +
							row.sick +
							row.annual +
							row.compensation +
							row.maternity +
							row.others}
					</span>
				);
			},
		},
		{
			dataField: "department",
			text: "Department",
			sort: true,
			headerStyle: {
				width: "20%",
			},
		},
		{
			dataField: "developmentCenter",
			text: "Development Center",
			sort: true,
			headerStyle: {
				width: "20%",
			},
		},
		{
			dataField: "systemRole",
			text: "System Role",
			sort: true,
			headerStyle: {
				width: "20%",
			},
		},
		{
			dataField: "joiningDate",
			text: "Joining Date",
			sort: true,
			formatter: (cell, row) => {
				return (
					<span>
						{row.joiningDate
							? moment(row.joiningDate).format(TableDateFormat)
							: "Not avaliable"}
					</span>
				);
			},
		},
		{
			dataField: "emergencyContactName",
			text: "Emergency Contact Name",
			sort: true,
		},
		{
			dataField: "emergencyContactPhone1",
			text: "Emergency Contact Phone1",
			sort: true,
		},
		{
			dataField: "emergencyContactPhone2",
			text: "Emergency Contact Phone2",
			sort: true,
		},
		{
			dataField: "emergencyContactAddress",
			text: "Emergency Contact Address",
			sort: true,
		},
		{
			dataField: "withoutPay",
			text: "Without Pay Leaves",
			sort: true,
		},
		{
			dataField: "sick",
			text: "Sick Leaves",
			sort: true,
		},
		{
			dataField: "annual",
			text: "Annual Leaves",
			sort: true,
		},
		{
			dataField: "compensation",
			text: "Compensation Leaves",
			sort: true,
		},
		{
			dataField: "maternity",
			text: "Maternity Leaves",
			sort: true,
		},
		{
			dataField: "others",
			text: "Other Leaves",
			sort: true,
		},
		{
			dataField: "action",
			text: "Action",
			events: {
				onClick: (e) => {
					e.stopPropagation(); // To stop navigation to detail screen
				},
			},
			formatter: (cell, row) => {
				return (
					<>
						<div className="navLinkClass align-items-center">
							<Link
								to={{
									pathname: `/ModifyEmployee/${row.id}`,
								}}
							>
								<img
									style={
										empDesignation.toString() === "4" ||
										empId === "180"
											? { height: "20px", width: "20px" }
											: {
													height: "20px",
													width: "20px",
													marginRight: "6px",
											  }
									}
									src={Edit}
									alt="Edit"
									title="Modify Employee"
								/>
							</Link>
							{empDesignation.toString() === "4" ||
							empId === "180" ? null : (
								<Link
									to={
										empRole.includes("3")
											? {
													pathname: `/AdminViewResourceLeavesInfo/${row.id}`,
											  }
											: {
													pathname: `/spResourceLeavesInfo/${row.id}`,
											  }
									}
								>
									<FontAwesomeIcon
										title="View Leaves Info"
										icon={faEye}
										style={{
											height: "20px",
											width: "20px",
											verticalAlign: "middle",
											marginLeft: "10px",
											color: "#43a3a5",
										}}
									/>
								</Link>
							)}
						</div>
					</>
				);
			},
		},
	];
	useEffect(() => {
		let pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		const header = {
			Authorization: `Bearer ${token}`,
		};

		if (empRole.includes("3")) {
			pageSize = GlobalPaginationSize.AdminPaginationSize;
			setNumberOfItemsPerPage(GlobalPaginationSize.AdminPaginationSize);
		}

		//get status list
		axios
			.get(`${ViewEmployees_API.GetStatusList}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const statusList = data.statuses;
					statusList.sort((a, b) => a.label.localeCompare(b.label));
					statusList.unshift({ value: 0, label: "All" });
					setStatusList(statusList);
					if (sessionStorage.getItem("ViewEmployees")) {
						if (
							JSON.parse(
								sessionStorage.getItem("ViewEmployees")
							)[1] != null
						)
							setSelectedStatus(
								JSON.parse(
									sessionStorage.getItem("ViewEmployees")
								)[1]
							);
						else setSelectedStatus({ value: 0, label: "All" });
					} else setSelectedStatus({ value: 0, label: "All" });
				}
			});

		//get designation list
		axios
			.get(`${ViewEmployees_API.GetDesignationList}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const employeeList = data.designations;
					if (sessionStorage.getItem("ViewEmployees")) {
						if (
							JSON.parse(
								sessionStorage.getItem("ViewEmployees")
							)[0]
						) {
							setSelectedDesignation(
								JSON.parse(
									sessionStorage.getItem("ViewEmployees")
								)[0]
							);
						} else
							setSelectedDesignation({ value: 0, label: "All" });
					} else setSelectedDesignation({ value: 0, label: "All" });

					employeeList.sort((a, b) => a.label.localeCompare(b.label));
					employeeList.unshift({ value: 0, label: "All" });
					setDesignationList(employeeList);
				}
			});

		//get Employee list

		axios
			.get(
				`${
					ViewEmployees_API.GetViewEmployeesList
				}?PageSize=${pageSize}&PageNumber=${pageNum}&Status=${
					sessionStorage.getItem("ViewEmployees")
						? JSON.parse(sessionStorage.getItem("ViewEmployees"))[1]
							? JSON.parse(
									sessionStorage.getItem("ViewEmployees")
							  )[1].value
							: 0
						: 0
				}&designation=${
					sessionStorage.getItem("ViewEmployees")
						? JSON.parse(sessionStorage.getItem("ViewEmployees"))[0]
							? JSON.parse(
									sessionStorage.getItem("ViewEmployees")
							  )[0].value
							: 0
						: 0
				}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: header,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setViewEmployeesData(res.data.employeeInfo);
				}
			});
		setApiHeaderToken(header);
	}, []);

	const updateTableData = (designation, status) => {
		setIsLoading(true);
		let apiUrl = "";

		if (searchInput === "")
			apiUrl = `${ViewEmployees_API.GetViewEmployeesList}?PageSize=${numberOfItemsPerPage}&Status=${status}&designation=${designation}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		else
			apiUrl = `${ViewEmployees_API.GetViewEmployeesList}?PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&Status=${status}&designation=${designation}&SortBy=${sortBy.dataField}_${sortBy.order}&SearchTerm=${searchInput}`;

		axios
			.get(apiUrl, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setViewEmployeesData(res.data.employeeInfo);
				}
			});
	};

	const handleSearch = (event) => {
		setIsLoading(true);
		const value = event.target.value;
		setSearchInput(value);

		if (value === "") {
			axios
				.get(
					`${
						ViewEmployees_API.GetViewEmployeesList
					}?PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Status=${
						selectedStatus.value
					}&designation=${selectedDesignation.value}&SortBy=${
						sortBy.dataField
					}_${sortBy.order}`,
					{
						headers: apiHeaderToken,
					}
				)
				.then((res) => {
					if (res.status === 200) {
						setPageNum(1);
						setIsLoading(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setViewEmployeesData(res.data.employeeInfo);
					}
				});
		} else {
			axios
				.get(
					`${
						ViewEmployees_API.GetViewEmployeesList
					}?PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Status=${
						selectedStatus.value
					}&designation=${selectedDesignation.value}&SortBy=${
						sortBy.dataField
					}_${sortBy.order}&SearchTerm=${value}`,
					{
						headers: apiHeaderToken,
					}
				)
				.then((res) => {
					if (res.status === 200) {
						setPageNum(1);
						setIsLoading(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setViewEmployeesData(res.data.employeeInfo);
					}
				});
		}
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);

		axios
			.get(
				`${
					ViewEmployees_API.GetViewEmployeesList
				}?PageNumber=${1}&PageSize=${PageSize}&Status=${
					selectedStatus.value
				}&designation=${selectedDesignation.value}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}${
					searchInput ? "&SearchTerm=" + searchInput : ""
				}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setViewEmployeesData(res.data.employeeInfo);
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
			if (searchInput === "")
				apiURL = `${ViewEmployees_API.GetViewEmployeesList}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&designation=${selectedDesignation.value}&SortBy=${sortField}_${sortOrder}`;
			else
				apiURL = `${ViewEmployees_API.GetViewEmployeesList}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&designation=${selectedDesignation.value}&SortBy=${sortField}_${sortOrder}&SearchTerm=${searchInput}`;
		} else if (type === "pagination") {
			getData = true;

			if (searchInput === "")
				apiURL = `${ViewEmployees_API.GetViewEmployeesList}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&designation=${selectedDesignation.value}&SortBy=${sortBy.dataField}_${sortBy.order}`;
			else
				apiURL = `${ViewEmployees_API.GetViewEmployeesList}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&designation=${selectedDesignation.value}&SortBy=${sortBy.dataField}_${sortBy.order}&SearchTerm=${searchInput}`;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: apiHeaderToken,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setViewEmployeesData(res.data.employeeInfo);
					}
				});
		}
	};
	const exportToExcel = () => {
		setShowBtnLoading(true);
		axios
			.get(
				`${ViewEmployees_API.ExportToExcel}?Status=${selectedStatus.value}&Designation=${selectedDesignation.value}`,
				{
					headers: { Authorization: `Bearer ${token}` },
					responseType: "blob",
				}
			)
			.then(({ data }) => {
				const url = window.URL.createObjectURL(new Blob([data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "viewEmployees.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
					setShowBtnLoading(false);
				}
			});
	};
	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (sessionStorage.getItem("ViewEmployees"))
			obj = JSON.parse(sessionStorage.getItem("ViewEmployees"));
		if (property === "designation") obj[0] = value;
		else if (property === "status") obj[1] = value;
		sessionStorage.setItem("ViewEmployees", JSON.stringify(obj));
	};
	const rowEvents = {
		onClick: (e, row) => {
			history.push({
				pathname: `/ModifyEmployee/${row.id}`,
			});
		},
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empRole = userDetails.empRole;
				empId = userDetails.id;
				empDesignation = userDetails.designation;
				return userDetails.empRole.includes("3") ||
					userDetails.designation.toString() === "4" ||
					userDetails.id.toString() === "180" ||
					userDetails.id.toString() === "269" ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="View Employees"
								headerBorder="false"
							/>

							<FilterationBar
								designations={designationList}
								selectedDesignation={selectedDesignation}
								onDesignationChange={(value) => {
									setSelectedDesignation(value);
									storeFiltersStates(value, "designation");
									updateTableData(
										value.value,
										selectedStatus.value
									);
								}}
								status={statusList}
								selectedStatus={selectedStatus}
								onStatusChange={(value) => {
									setSelectedStatus(value);
									storeFiltersStates(value, "status");
									updateTableData(
										selectedDesignation.value,
										value.value
									);
								}}
							/>
							<CustomeSearchBar
								handleSearch={(event) => handleSearch(event)}
								tooltip={
									"Search by code, name, designation, login info and status"
								}
								btnTitle="Export To Excel"
								onClick={exportToExcel}
								className="d-flex exportExcel-btn"
								exportToExcelBtn={true}
								showBtnLoading={showBtnLoading}
								disabled={
									!viewEmployeesData.length || showBtnLoading
								}
							/>
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={searchInput}
											keyField={"code"}
											columns={
												empRole.includes("3")
													? adminGetColumns
													: getColumns
											}
											items={viewEmployeesData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
											adminPagination={empRole.includes(
												"3"
											)}
											rowEvents={rowEvents}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default ViewEmployees;
